import { useState } from 'react'
import {
  Wrapper,
  CropperWrapper,
  CropperContainerWrapper,
  CropperOptionsWrapper,
  Subtitle,
  ChangeImage,
} from './styled'
import { Row, Col, Slider, Upload, Button } from 'antd'
import Cropper from 'react-easy-crop'
import getCroppedImg from './cropImage'
import { Modal } from '../modal'
import { ModalButtons } from '../modalButtons'
import { RcFile } from 'antd/lib/upload'

interface IProps {
  title: string
  image: any
  loadImage: Function
  cancel: () => void
  variant: any
  beforeUpload: Function
}

export const CropImage = ({
  title,
  image,
  loadImage,
  cancel,
  variant,
  beforeUpload,
}: IProps) => {
  const [crop, setCrop] = useState({ x: 0, y: 0 })
  const [rotation, setRotation] = useState(0)
  const [zoom, setZoom] = useState(3)
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null)

  const onCropComplete = (_croppedArea: any, croppedAreaPixels: any) => {
    setCroppedAreaPixels(croppedAreaPixels)
  }

  const save = async () => {
    try {
      const croppedImage = await getCroppedImg(
        image,
        croppedAreaPixels,
        rotation
      )
      fetch(croppedImage)
        .then((res) => res.blob())
        .then((newImage) => {
          loadImage(newImage)
        })
    } catch (e) {
      console.error(e)
    }
  }

  const onChangeZoom = (zoom: any) => {
    setZoom(zoom)
  }

  const onChangeRotation = (rotation: any) => {
    setRotation(rotation)
  }

  return (
    <Modal
      title={title}
      maxheight={400}
      maxwidth={600}
      actions={
        <Row gutter={16} type="flex" justify="space-around" align="middle">
          <Col span={12}>
            <ChangeImage>
              <Upload
                beforeUpload={(file: RcFile) => beforeUpload(file)}
                accept=".jpg, .jpeg, .png"
                showUploadList={false}
              >
                <Button>Cambiar imagen</Button>
              </Upload>
            </ChangeImage>
          </Col>
          <Col span={12}>
            <ModalButtons
              primaryText="Guardar"
              primaryAction={save}
              secondaryText="Cancelar"
              secondaryAction={cancel}
            />
          </Col>
        </Row>
      }
      close={() => cancel()}
    >
      <Wrapper>
        <CropperWrapper>
          <CropperContainerWrapper>
            <Cropper
              image={image}
              crop={crop}
              rotation={rotation}
              zoom={zoom}
              showGrid={false}
              cropSize={
                variant === 'rect'
                  ? { width: 900, height: 200 }
                  : { width: 175, height: 175 }
              }
              onCropChange={setCrop}
              onRotationChange={setRotation}
              onCropComplete={onCropComplete}
              onZoomChange={setZoom}
            />
          </CropperContainerWrapper>
          <CropperOptionsWrapper>
            <Row gutter={16} type="flex" justify="space-around" align="middle">
              <Col span={12}>
                <Subtitle>Acercamiento</Subtitle>
                <Slider
                  value={zoom}
                  min={1}
                  max={3}
                  step={0.1}
                  onChange={(zoom: any) => onChangeZoom(zoom)}
                />
              </Col>
              <Col span={12}>
                <Subtitle>Rotación</Subtitle>
                <Slider
                  value={rotation}
                  min={0}
                  max={360}
                  step={1}
                  onChange={(rotation: any) => onChangeRotation(rotation)}
                />
              </Col>
            </Row>
          </CropperOptionsWrapper>
        </CropperWrapper>
      </Wrapper>
    </Modal>
  )
}
